import { render, staticRenderFns } from "./DesktopSearch.vue?vue&type=template&id=be93213a&"
import script from "./DesktopSearch.vue?vue&type=script&lang=js&"
export * from "./DesktopSearch.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSearch.vue?vue&type=style&index=0&id=be93213a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports